import {
  SIMULATE_ASSET_STORAGE_KEY,
  buildSimulatedAssetResponse,
  matchesSimulateAsset,
  parseSimulateAssetScenario,
} from './simulate-asset-failure.util';
import { isSimulationEnabled } from './simulate-failure.state';

/**
 * The one place a sheet's form-definition JSON is requested.
 *
 * Normally exactly `fetch(assetPath)`. When the QA simulate-failure switch is on
 * (`simulateFailureEnabled` runtime flag) and a scenario matches this file, it
 * answers with a synthetic non-OK / unreadable response, or rejects as offline
 * would — see `simulate-asset-failure.util.ts` for how a tester drives it.
 *
 * `angular.json` → `configurations.production.fileReplacements` swaps this file
 * for `schema-asset-fetch.production.ts`, a bare `fetch`, so none of the
 * simulation ships in a production build. Keep both files' exports identical.
 */
export function fetchSchemaAsset(assetPath: string): Promise<Response> {
  if (isSimulationEnabled()) {
    let scenario = null;
    try {
      scenario = parseSimulateAssetScenario(localStorage.getItem(SIMULATE_ASSET_STORAGE_KEY), Date.now());
    } catch {
      // Storage can be blocked (private window, site data disabled): behave as "no scenario".
    }
    if (scenario && matchesSimulateAsset(scenario, assetPath)) {
      console.warn(`[simulate-failure] ${assetPath} -> synthetic ${scenario.mode} (role ${scenario.role})`);
      const response = buildSimulatedAssetResponse(scenario);
      return response ? Promise.resolve(response) : Promise.reject(new TypeError('Failed to fetch (simulated offline)'));
    }
  }
  return fetch(assetPath);
}
